import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const applicationQueuedLearnModalComponent = {
  footer: {
    closeButton: 'application-queued-learn-modal.footer.close-button',
    root: 'application-queued-learn-modal.footer.root',
  },
  header: {
    closeButton: 'application-queued-learn-modal.header.close-button',
    h1: 'application-queued-learn-modal.header.h1',
    root: 'application-queued-learn-modal.header.root',
  },
  main: {
    p: 'application-queued-learn-modal.main.p',
    root: 'application-queued-learn-modal.main.root',
  },
  root: 'application-queued-learn-modal.root',
} as const satisfies ComponentLocatorMap;
